/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * The schema for creating a new CredentialSchema.
 */
export interface CredentialSchemaCreate {
    /** The URL of the published Meta Schema to copy from. */
    fromPublishedSchemaUrl?: string;
    /** The ID of the schema to copy from. */
    fromSchema?: string;
    schema?: Truvity.ClaimsSchemaOptional;
}
